/* eslint-disable */
import React, { useState } from 'react';
import styled from 'styled-components';

// Styled Components
const TextContainer = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: #333;
  margin-bottom: 16px;
`;

const Paragraph = styled.p`
  margin: 0 0 12px 0;
  &:last-child {
    margin-bottom: 0;
  }
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 14px;
  margin-top: 8px;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;

const CommentContainer = styled.div`
  padding: 16px;
  margin-bottom: 24px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
`;

const ReadMoreButtonStyle = styled.div`
  margin-bottom: 16px;
`;

// Helper Function
const formatTextWithParagraphs = (text, isReadMore, maxLength) => {
  if (!text) return [];

  const paragraphs = text.split('\n').filter(Boolean);
  let visibleText = [];
  let characterCount = 0;

  if (isReadMore && text.length > maxLength) {
    for (const paragraph of paragraphs) {
      if (characterCount + paragraph.length > maxLength) break;
      visibleText.push(paragraph);
      characterCount += paragraph.length;
    }
    return [...visibleText, '...'];
  }

  return paragraphs;
};

// ✅ Fixed ReadMore Component
const ReadMore = ({ text = '', maxLength = 240 }) => {
  const [isReadMore, setIsReadMore] = useState(true);

  if (!text) return null;

  const formattedText = formatTextWithParagraphs(text, isReadMore, maxLength);

  return (
    <CommentContainer data-testid="test-comment-container">
      <TextContainer>
        {formattedText.map((paragraph, index) => (
          <Paragraph key={index}>{paragraph}</Paragraph>
        ))}
      </TextContainer>
      {text.length > maxLength && (
        <ReadMoreButtonStyle>
          <ToggleButton onClick={() => setIsReadMore(!isReadMore)}>
            {isReadMore ? 'Read more' : 'Show less'}
          </ToggleButton>
        </ReadMoreButtonStyle>
      )}
    </CommentContainer>
  );
};

// ✅ Ensure Proper Export
export default ReadMore;
